// Client-side hint for paid features; the API must authorize requests too.
// eslint-disable-next-line import/prefer-default-export
export function hasActiveSubscriptionUntil(
  until: string | null | undefined,
  nowMs: number = Date.now(),
): boolean {
  if (!until) return false;
  const expiresAt = Date.parse(until);
  return Number.isFinite(expiresAt) && expiresAt > nowMs;
}
